/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateGrantsControllerCreateMutationResponse, TemplateGrantsControllerCreate400, TemplateGrantsControllerCreate401, TemplateGrantsControllerCreate403 } from "../../models/checklistsController/TemplateGrantsControllerCreate";

function getTemplateGrantsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-grants` as const }  
  return res
}

/**
 * @summary Grant templates to a scope
 * {@link /api/v1/checklist-template-grants}
 */
export async function templateGrantsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateGrantsControllerCreateMutationResponse, ResponseErrorConfig<TemplateGrantsControllerCreate400 | TemplateGrantsControllerCreate401 | TemplateGrantsControllerCreate403>, unknown>({ method : "POST", url : getTemplateGrantsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}